import React from 'react'
import styled from 'styled-components'

import Select from 'react-select'

const StyledFormSelect = styled.div`
  position: relative;
  margin-bottom: 12px;
/* 
  &:focus-within label {
    color: ${(props) => (props.error ? '#9f2121' : '#4c84ff')};
  } */
`

const StyledSelect = styled.select`
  display: flex;
  align-items: center;

  height: 42px;
  width: 100%;

  color: #8b93a7;
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 13px;

  padding: 0px 10px;
  background-color: #fff;

  border: 1px solid ${(props) => (props.error ? '#9f2121' : '#ececf0')};
  border-radius: 2px;

  outline: none;
`

const StyledInputTop = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 8px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 11px;
`

const StyledLabel = styled.label`
  display: block;
  flex: 0;
  margin-bottom: 0;
  color: ${(props) => (props.error ? '#9f2121' : '#b0bac9')};
  letter-spacing: 1.12px;
  text-transform: uppercase;
  white-space: nowrap;

  transition: all 0.5s;
`

const onSelectValueChanged = (callback) => ({ value }) => {
  callback({ target: { value } })
}

export default ({
  value,
  disabled,
  onChangeCallback,
  children,
  label,
  options
}) => {
  // const options = values.map(({ property_id, name }) => ({
  //   value: property_id,
  //   label: name
  // }))
  const selectValue = options.find((o) => o.value === value)

  const customStyles = {
    valueContainer: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'red' : 'blue'
    })
  }

  return (
    <StyledFormSelect>
      {label && (
        <StyledInputTop>
          <StyledLabel>{label}</StyledLabel>
        </StyledInputTop>
      )}
      <Select
        styles={customStyles}
        className="custom_select_style"
        value={selectValue}
        options={options}
        disabled={disabled}
        onChange={onSelectValueChanged(onChangeCallback)}
      >
        {children}
      </Select>
    </StyledFormSelect>
  )
}
